import { render, staticRenderFns } from "./scrollBoard.vue?vue&type=template&id=b5b4a4bc"
import script from "./scrollBoard.vue?vue&type=script&lang=js"
export * from "./scrollBoard.vue?vue&type=script&lang=js"
import style0 from "./scrollBoard.vue?vue&type=style&index=0&id=b5b4a4bc&prod&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports